import * as React from 'react';
import styled from 'styled-components';

import { ImageData } from '@packages/common';
import { SourceMaps } from '@packages/ui';

const StyledImage = styled.img`
  width: 100%;
  min-width: 100%;
  height: 100%;
`;

export const ProductTileImage: React.FC<{ imageData: ImageData }> = ({ imageData }) => {
  const { src, srcSetWebp, alt, width, height, sizes } = imageData;

  return (
    <picture>
      <SourceMaps srcSet={srcSetWebp} type="image/webp" sizes={sizes} />
      <StyledImage loading="lazy" src={src} alt={alt} width={width} height={height} />
    </picture>
  );
};
